import React from 'react';
import {
  Modal, ModalBody, ButtonToolbar, Button, Alert, Card, CardBody,
} from 'reactstrap';
import PropTypes from 'prop-types';

const ModalReport = ({
  userInfo, toggle, isModal,
}) => (
  <Modal
    isOpen={isModal}
    toggle={toggle}
    modalClassName="ltr-support"
    className="modal-dialog--header theme-light"
  >
    <div className="modal__header with-border">
      <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
      <h4 className="semiBold text-modal modal__title">
        Signaler {userInfo.given_name} comme décédé{userInfo.gender === 'female' && 'e'}
      </h4>
    </div>
    <ModalBody style={{ padding: '2rem' }}>
      <p className="fs14 mb-20">
        Nous prendrons les mesures suivantes une fois votre signalement abouti.
      </p>
      <Card className="mb-20 pb-0 assetCard">
        <CardBody>
          <div className="step-number smaller absolute">
            1
          </div>
          <p className="mt-0" style={{ paddingLeft: 50 }}>Empêcher les modifications futures du comptes Legitbee de {userInfo.given_name}.</p>
        </CardBody>
      </Card>
      <Card className="mb-20 pb-0 assetCard">
        <CardBody>
          <div className="step-number smaller absolute">
            2
          </div>
          <p className="mt-0" style={{ paddingLeft: 50 }}>Arrêter la facturation et le renouvellement de l'abonnement de {userInfo.given_name}.</p>
        </CardBody>
      </Card>
      <Card className="pb-0 assetCard">
        <CardBody>
          <div className="step-number smaller absolute">
            3
          </div>
          <p className="mt-0" style={{ paddingLeft: 50 }}>Garantir que vous - et les autres personnes de confiance - puissiez accéder à son Legitbee pour les 12 prochains mois.</p>
        </CardBody>
      </Card>
      <ButtonToolbar className="mt-20 justify-content-center form__button-toolbar">
        <Button onClick={toggle}>Annuler</Button>
        <Button disabled color="primary">Signaler</Button>
      </ButtonToolbar>
      <Alert color="warning" className="text-center mb-0">
        Fonction bientôt disponible. Pour le moment, veuillez transmettre votre signalement à l'adresse contact@legitbee.com afin de déclencher la procédure.
      </Alert>
    </ModalBody>
  </Modal>
);

ModalReport.propTypes = {
  isModal: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({}).isRequired,
  toggle: PropTypes.func.isRequired,
};

export default ModalReport;
